import {InstallationManual as InstallationManualType} from '@chekin/core';
import {InstallationSteps} from './components/InstallationSteps';
import {Value} from './components/Value';
import {useTranslation} from 'react-i18next';

type Props = {
  details: InstallationManualType;
};
export const InstallationManual = ({details}: Props) => {
  const {t} = useTranslation();
  const {smdp_address, activation_code, smdp_address_and_activation_code} = details;
  return (
    <div className="flex flex-col gap-6">
      {smdp_address && <Value label={t('esim.my.smdp_address')} value={smdp_address} />}
      {activation_code && (
        <Value label={t('esim.my.activation_code')} value={activation_code} />
      )}
      {smdp_address_and_activation_code && !(smdp_address || activation_code) && (
        <Value
          label={t('esim.my.smdp_address_and_activation_code')}
          value={smdp_address_and_activation_code}
        />
      )}

      <InstallationSteps steps={details.steps} />
    </div>
  );
};
